export default function IndustryLinks() {
 return (
  <div className="d-flex flex-column align-items-start">
   <a target="_blank" rel="noreferrer" href="/Industries/Equipment" className="info-link">equi-track for Equipment</a>
   <a target="_blank" rel="noreferrer" href="/Industries/Tools" className="info-link">equi-track for Tools</a>
   <a target="_blank" rel="noreferrer" href="/Industries/RopeAccess" className="info-link">equi-track for Rope Access</a>
   <a target="_blank" rel="noreferrer" href="/Industries/PlantHire" className="info-link">equi-track for Plant Hire</a>
  </div>
 )
}